var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-vacancy-admin" }, [
    _c("div", { staticClass: "page-vacancy-admin__vacancies-info-block" }, [
      _c("div", { staticClass: "page-vacancy-admin__vacancies-info" }, [
        _c("div", { staticClass: "page-vacancy-admin__vacancies-name" }, [
          _c("h4", { staticClass: "page-vacancy-admin__vacancies-title" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.vacancy.title) + "\n          "
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm.vacancy.salary_from
              ? _c(
                  "h4",
                  { staticClass: "page-vacancy-admin__vacancies-price" },
                  [
                    _vm._v(
                      "\n              от " +
                        _vm._s(
                          _vm.getFormattedSalary(_vm.vacancy.salary_from)
                        ) +
                        " "
                    ),
                    _vm.vacancy.salary_to
                      ? _c("span", [
                          _vm._v(
                            " до " +
                              _vm._s(
                                _vm.getFormattedSalary(_vm.vacancy.salary_to)
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" ₽\n            "),
                  ]
                )
              : _c(
                  "h4",
                  { staticClass: "page-vacancy-admin__vacancies-price" },
                  [_vm._v("\n              По договоренности\n            ")]
                ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-vacancy-admin__vacancies-status" }, [
          _vm.vacancy.is_active === true
            ? _c("p", { staticClass: "active" }, [_vm._v(" Активна ")])
            : _c("p", { staticClass: "inactive" }, [_vm._v(" Неактивна ")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-vacancy-admin__vacancies-data" }, [
          _c(
            "div",
            {
              staticClass:
                "page-vacancies__vacancies-location m-t-u color--main-ground-light",
            },
            [
              _c("IconLocation", { staticClass: "mr-4" }),
              _vm._v(
                "\n            " + _vm._s(_vm.vacancy.city) + "\n          "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "page-vacancies__vacancies-date m-t-u color--main-ground-light",
            },
            [
              _c("IconCalendar", { staticClass: "mr-4" }),
              _vm._v("\n            Опубликовано "),
              _vm.vacancy.start_published
                ? _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getDateFormatISO(_vm.vacancy.start_published)
                        ) +
                        " "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-vacancy-admin__vacancies-button" }, [
        _c("div", { staticClass: "button-edit" }, [
          _c(
            "a",
            { attrs: { href: "/vacancy/update/" + _vm.vacancy.id } },
            [_c("iconEdit")],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "button-delete",
            on: {
              click: function ($event) {
                return _vm.deleteVacancy(_vm.vacancy.id)
              },
            },
          },
          [_c("iconDelete")],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "page-vacancy-admin__dividing-line" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }